export default __webpack_public_path__ + "static/media/AvatarKids-14.ae2f3c3f.png";